<template>
  <a href="#" class="mb-6 block text-2xl font-bold text-gray-dark" @click.prevent="$emit('update:modelValue', !modelValue)">
    <svg
      v-if="modelValue"
      class="-mt-1 mr-2 inline-block"
      width="16"
      height="2"
      viewBox="0 0 16 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2L0 2V0L16 1.54972e-06V2Z" fill="black" />
    </svg>
    <svg
      v-else
      class="-mt-1 mr-2 inline-block"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 7V0H7L7 7L0 7V9L7 9L7 16H9V9L16 9V7L9 7Z" fill="#4D4D4D" />
    </svg>
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
  },

  emits: ['update:modelValue'],
}
</script>
